module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "me"
  }, [_c('v-header', {
    attrs: {
      "show_parent": _vm.show,
      "title": _vm.title,
      "showBackButton": true,
      "showMenuButton": false,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "me-detail"
  }, [_c('div', {
    staticClass: "me-header"
  }, [(_vm.user.avatar_url) ? _c('img', {
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/imgs/unlogin.jpg"),
      "alt": "unlogin.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.user.loginname || '暂未登录'))])]), _vm._v(" "), _c('div', {
    staticClass: "me-item item1"
  }, [_c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("发表主题" + _vm._s(_vm.user.recent_topics && _vm.user.recent_topics.length || 0)), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("我的消息" + _vm._s(_vm.user.recent_replies && _vm.user.recent_replies.length || 0)), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])])]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "me-item item2"
  }, [_c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("社区周榜"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("意见反馈"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("系统设置"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33152bcd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Me.vue
// module id = 135
// module chunks = 1